const updateItems = [
  {
    time: '10分钟前',
    title: '突发：某知名选秀节目宣布暂停录制，疑似涉及选手资格造假调查',
    tag: '突发',
    tagColor: 'bg-primary-500',
  },
  {
    time: '45分钟前',
    title: '电竞大赛主办方发布声明：将对疑似假赛事件启动独立调查程序',
    tag: '跟进',
    tagColor: 'bg-accent-500',
  },
  {
    time: '2小时前',
    title: '网红主播大赛投票系统出现异常，技术团队称系服务器过载非人为操控',
    tag: '热议',
    tagColor: 'bg-primary-500',
  },
  {
    time: '4小时前',
    title: '综艺节目导师阵容变动消息确认：三位导师合约到期将不再续约',
    tag: '确认',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '6小时前',
    title: '才艺大赛选手家长集体发声：要求公开评分细则及评委打分原始记录',
    tag: '争议',
    tagColor: 'bg-primary-500',
  },
  {
    time: '10小时前',
    title: '大型赛事赞助商被曝资金链断裂，多场赛事面临延期风险',
    tag: '内幕',
    tagColor: 'bg-accent-500',
  },
  {
    time: '14小时前',
    title: '年度选秀冠军首度公开回应合同争议：称一切合法合规并保留追诉权',
    tag: '回应',
    tagColor: 'bg-secondary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            每日大赛黑料实时更新，大赛吃瓜资讯滚动播报
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {updateItems.map((item, i) => (
            <div
              key={i}
              className="relative flex gap-4 pb-6 md:pb-8 group cursor-pointer"
            >
              <div className="flex flex-col items-center">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 flex-shrink-0 ${item.tagColor}`}></div>
                {i < updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-300/60 mt-2"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className={`px-2 py-0.5 ${item.tagColor} text-background-50 text-xs font-medium rounded whitespace-nowrap`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}